<template>
  <main class="maintenance">
    <section class="maintenance_card">
      <img
        class="maintenance_logo"
        src="@/assets/img/logo.svg"
        title="SECOM Sights logo"
      />
      <maintenance-card />
    </section>
    <footer class="maintenance_footer">
      <span class="maintenance_footer-title">個人情報保護方針</span>
      <span class="maintenance_footer-caption"
        >Copyright(C) 2000-2021 SECOM CO., LTD. All Rights Reserved.</span
      >
    </footer>
  </main>
</template>

<script>
import MaintenanceCard from '@/components/MaintenanceCard.vue';
export default {
  name: 'Maintenance',
  components: { MaintenanceCard },
};
</script>

<style lang="scss">
.maintenance {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100%;
  @media (max-width: 576px) {
    .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 100%;
      padding: 20px;
      height: 100%;
    }
    &_card {
      padding: 20px;
    }
    &_header-gap {
      display: none;
    }
  }
  &_card {
    width: 100%;
  }
  &_header-gap {
    height: 100px;
  }
  &_logo {
    display: block;
    height: 24px;
    width: 165.4px;
    margin: 35px auto;
    @media (max-width: 576px) {
      margin: 10px auto;
    }
  }
  &_footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
    &-caption {
      margin: 10px 0;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #989898;
    }
  }
}
</style>
